import { Component, Input } from "@angular/core";

/**
 * Generated class for the ExpandoParagraphComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "expando-paragraph",
  templateUrl: "expando-paragraph.html",
})
export class ExpandoParagraphComponent {
  @Input() text: string;
  @Input() btnId: string;
  truncateLength = 300;
  initialTruncateLength = 300;

  constructor() {}

  showMore() {
    this.truncateLength = this.truncateLength == 300 ? 10000 : 300;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/expando-paragraph/expando-paragraph.ts